import { cn } from '@/lib/cn';

/** The Lumina mark: a lantern whose flame is an open page, set in a sapphire tile. */
export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true" className={cn('shrink-0', className)}>
      <rect width="40" height="40" rx="10" fill="#2A4BC6" />
      <path d="M16.2 10.6a3.8 3.8 0 0 1 7.6 0" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M13.2 14h13.6l1.1 3.2H12.1L13.2 14Z" fill="#fff" />
      <path d="M12.9 18.2h14.2l-1.4 11.3a1.6 1.6 0 0 1-1.6 1.4h-8.2a1.6 1.6 0 0 1-1.6-1.4l-1.4-11.3Z" fill="#fff" fillOpacity="0.16" stroke="#fff" strokeOpacity="0.9" strokeWidth="1.3" />
      <path d="M20 21c-1 1.2-3.6 2.2-3.6 4.6A3.6 3.6 0 0 0 20 29.2a3.6 3.6 0 0 0 3.6-3.6C23.6 23.2 21 22.2 20 21Z" fill="#DFF1FF" />
      <path d="M20 23.6v4.9M17.9 25.9c1.1-.4 1.7-.3 2.1.4M22.1 25.9c-1.1-.4-1.7-.3-2.1.4" stroke="#2441A8" strokeWidth="0.9" strokeLinecap="round" />
      <rect x="12" y="31.6" width="16" height="2.6" rx="1.2" fill="#fff" />
    </svg>
  );
}

export interface LogoProps {
  size?: number;
  /** `onDark` for the navy sidebar and kiosk; `auto` follows the theme. */
  tone?: 'auto' | 'onDark';
  hideWordmark?: boolean;
  className?: string;
  subtitle?: string;
}

/** Mark + "Lumina" wordmark in Fraunces. */
export function Logo({ size = 32, tone = 'auto', hideWordmark, className, subtitle }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark size={size} />
      {!hideWordmark && (
        <span className="flex flex-col leading-none">
          <span className={cn('font-display font-semibold tracking-tight', tone === 'onDark' ? 'text-white' : 'text-ink')} style={{ fontSize: size * 0.62 }}>
            Lumina
          </span>
          {subtitle && <span className={cn('mt-1 text-[0.625rem] font-medium uppercase tracking-[0.18em]', tone === 'onDark' ? 'text-sapphire-300' : 'text-ink-subtle')}>{subtitle}</span>}
        </span>
      )}
    </span>
  );
}
